module.exports = __webpack_public_path__ + "img/30_49.a66895cb.png";